module.exports = "<div class=\"login-info\">\n  <span *ngIf=\"user?.picture\"><a (click)=\"toggleShortcut()\">\n\t   <img [src]=\"user.picture\" alt=\"me\"\n          class=\"online\"/><span style=\"text-transform: none!important\">{{user.username }}</span> <!-- <i class=\"fa fa-angle-down\"></i> www-->\n    </a>\n   </span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/user/login-info/login-info.component.html
// module id = ../../../../../src/app/shared/user/login-info/login-info.component.html
// module chunks = main